export const OUTLET_ROOT_ID = '__ame_outlet__'
export const OUTLET_ROOT_NAME = 'Ame Outlet'
export const OUTLET_SHOP_ID = '854'

export const isOutletRootNode = (node) =>
  node?.source === 'outlet' && node?.level === 'outlet_root'

export const isOutletBranchActive = (node) => isOutletRootNode(node)
